/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsDynamoDbSnapshotProperties } from '../models/AwsDynamoDbSnapshotProperties';
import { AwsEbsVolumeSnapshotProperties } from '../models/AwsEbsVolumeSnapshotProperties';
import { AwsEc2SnapshotProperties } from '../models/AwsEc2SnapshotProperties';
import { AwsEksNamespaceSnapshotProperties } from '../models/AwsEksNamespaceSnapshotProperties';
import { AzureMssqlSnapshotProperties } from '../models/AzureMssqlSnapshotProperties';
import { AzureVmSnapshotProperties } from '../models/AzureVmSnapshotProperties';
import { GcpCloudSqlSnapshotProperties } from '../models/GcpCloudSqlSnapshotProperties';
import { GcpDiskSnapshotProperties } from '../models/GcpDiskSnapshotProperties';
import { GcpVmSnapshotProperties } from '../models/GcpVmSnapshotProperties';

/**
* Properties of the original resource at the time the snapshot was taken. The properties present in this object change depending on the value set in `resourceType`. 
*/
export class ResourceSnapshotProperties {
  'awsEc2'?: AwsEc2SnapshotProperties | null;
  'awsEbsVolume'?: AwsEbsVolumeSnapshotProperties | null;
  'awsEksNamespace'?: AwsEksNamespaceSnapshotProperties | null;
  'awsDynamoDb'?: AwsDynamoDbSnapshotProperties | null;
  'azureVm'?: AzureVmSnapshotProperties | null;
  'azureMssql'?: AzureMssqlSnapshotProperties | null;
  'gcpVm'?: GcpVmSnapshotProperties | null;
  'gcpCloudSql'?: GcpCloudSqlSnapshotProperties | null;
  'gcpDisk'?: GcpDiskSnapshotProperties | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "awsEc2",
      "baseName": "awsEc2",
      "type": "AwsEc2SnapshotProperties",
      "format": ""
    },
    {
      "name": "awsEbsVolume",
      "baseName": "awsEbsVolume",
      "type": "AwsEbsVolumeSnapshotProperties",
      "format": ""
    },
    {
      "name": "awsEksNamespace",
      "baseName": "awsEksNamespace",
      "type": "AwsEksNamespaceSnapshotProperties",
      "format": ""
    },
    {
      "name": "awsDynamoDb",
      "baseName": "awsDynamoDb",
      "type": "AwsDynamoDbSnapshotProperties",
      "format": ""
    },
    {
      "name": "azureVm",
      "baseName": "azureVm",
      "type": "AzureVmSnapshotProperties",
      "format": ""
    },
    {
      "name": "azureMssql",
      "baseName": "azureMssql",
      "type": "AzureMssqlSnapshotProperties",
      "format": ""
    },
    {
      "name": "gcpVm",
      "baseName": "gcpVm",
      "type": "GcpVmSnapshotProperties",
      "format": ""
    },
    {
      "name": "gcpCloudSql",
      "baseName": "gcpCloudSql",
      "type": "GcpCloudSqlSnapshotProperties",
      "format": ""
    },
    {
      "name": "gcpDisk",
      "baseName": "gcpDisk",
      "type": "GcpDiskSnapshotProperties",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ResourceSnapshotProperties.attributeTypeMap;
  }

  public constructor() {
  }
}

